import React from 'react';
import { Section02_Styled, Title, Description, Action, Image } from './styled';
import Grid from '../Grid';

const Section02 = () => {
  return (
    <Section02_Styled>
      <Grid>
        <Title>IoT</Title>
        <Description>
          Use the identity of the IoT device instead of a user identity to streamline a secure IoT
          implementation.
        </Description>
        <Action href="https://auth0.com/blog/using-m2m-authorization/">Learn more</Action>
      </Grid>
      <Image>
        <img
          src="https://cdn.auth0.com/website/machine-to-machine/images/iot/bg-iot-v1.png"
          alt="IoT"
        />
      </Image>
    </Section02_Styled>
  );
};

export default Section02;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-02/Section-02.js